import { BaseException, BaseExceptionContext } from './base.exception';

interface BadRequestExceptionContext extends BaseExceptionContext {}

export class BadRequestException extends BaseException {
  constructor(entity: string, context: BadRequestExceptionContext) {
    super(`Bad request when processing ${entity}`, context);
  }
}
